import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ASSETS } from "@/data/content";

const BOOT_LINES = [
    "> initializing command center...",
    "> loading secure runtime...",
    "> loading agent identity...",
    "> initializing verification layer...",
    "> connecting evidence engine...",
    "> synchronizing economic layer...",
];

export const Boot = ({ onDone }) => {
    const [lines, setLines] = useState(0);
    const [ready, setReady] = useState(false);
    const [skipped, setSkipped] = useState(false);

    useEffect(() => {
        if (skipped) return;
        if (lines < BOOT_LINES.length) {
            const t = setTimeout(() => setLines((l) => l + 1), 260);
            return () => clearTimeout(t);
        }
        const t = setTimeout(() => setReady(true), 320);
        const t2 = setTimeout(onDone, 1250);
        return () => {
            clearTimeout(t);
            clearTimeout(t2);
        };
    }, [lines, skipped, onDone]);

    const skip = () => {
        setSkipped(true);
        onDone();
    };

    return (
        <AnimatePresence>
            {!skipped && (
                <motion.div
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                    className="fixed inset-0 z-[80] flex items-center justify-center bg-[#05070B]"
                    data-testid="boot-screen"
                    role="status"
                    aria-label="AgentVM boot sequence"
                >
                    <div className="vm-grid-bg absolute inset-0 opacity-60" aria-hidden="true" />
                    <div className="relative w-full max-w-lg px-6">
                        <div className="mb-6 flex items-center gap-4">
                            <motion.img
                                src={ASSETS.logo}
                                alt="AgentVM logo"
                                className="h-12 w-12 border border-[rgba(0,217,255,0.4)] object-cover"
                                initial={{ opacity: 0, scale: 0.8 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.6 }}
                            />
                            <div>
                                <div className="font-mono text-sm tracking-[0.3em] text-[#F5F9FF]">AGENTVM://BOOT</div>
                                <div className="vm-micro-dim mt-1">SECURE ENVIRONMENT INITIALIZATION</div>
                            </div>
                        </div>
                        <div className="vm-panel scanlines relative p-5 font-mono text-xs leading-6">
                            {BOOT_LINES.slice(0, lines).map((line, i) => (
                                <motion.div key={i} initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-[#B8C7D9]">
                                    {line}
                                </motion.div>
                            ))}
                            {ready ? (
                                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="mt-3 text-[#00D9FF] vm-glow">
                                    AGENTVM SYSTEM READY<span className="vm-blink">_</span>
                                </motion.div>
                            ) : (
                                <span className="vm-blink text-[#00D9FF]">_</span>
                            )}
                        </div>
                        <button
                            data-testid="boot-skip"
                            onClick={skip}
                            className="vm-micro-dim mt-4 border border-[rgba(0,217,255,0.2)] px-3 py-1.5 transition-colors hover:border-[#00D9FF]/50 hover:text-[#00D9FF]"
                        >
                            [ SKIP ]
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
